import { useRef } from "react";
import { useHistory } from "react-router-dom";
import useBranchId from "./useBranchId";
import useDidUpdateEffect from "./useDidUpdateEffect";
import useLocationHook from "./useLocationHook";

const useChangeBranchHook = () => {
  const ref = useRef<number>();
  const branch = useBranchId();

  const { push } = useHistory();

  const {
    isOrderDetailPage,
    isUserDetailPage,
    isUserOrdersPage,
    isVersionDetailPage,
    isReceiptDetailPage,
    isReviewDetailPage,
    isPushDetailPage,
    isNewsletterDetailPage,
    isDiscountDetailPage,
    isWebsiteSettingsDetail,
    isZipcodeDetail,
  } = useLocationHook();

  useDidUpdateEffect(() => {
    if (ref.current !== undefined && ref.current !== branch) {
      if (isOrderDetailPage) {
        push("/orders/archive");
      } else if (isUserDetailPage || isUserOrdersPage) {
        push("/users");
      } else if (isVersionDetailPage) {
        push("/versions");
      } else if (isReceiptDetailPage) {
        push("/receipts");
      } else if (isReviewDetailPage) {
        push("/reviews");
      } else if (isPushDetailPage) {
        push("/marketing/push");
      } else if (isNewsletterDetailPage) {
        push("/marketing/newsletter");
      } else if (isDiscountDetailPage) {
        push("/kortingen");
      } else if (isWebsiteSettingsDetail) {
        push("/websitesettings");
      } else if (isZipcodeDetail) {
        push("/zipcodes");
      }
    }
    ref.current = branch;
  }, [branch]);
};

export default useChangeBranchHook;
